import React from "react"
import Layout from "../components/Layout/Layout"
import SEO from "../components/SEO/seo"
import Donate from "../components/Pages/Donate/Donate"

const DonatePage = () => (
  <Layout>
    <SEO title="Donate" ogTitle={'Employee led Philanthropy'}/>
    <Donate/>
  </Layout>
)

export default DonatePage
